var exports = {
  "kL": "xfd349460--90fd95--container",
  "Qs": "xfd349460--90fd95--content",
  "kb": "xfd349460--90fd95--left",
  "Ot": "xfd349460--90fd95--reasons",
  "l": "xfd349460--90fd95--reason",
  "pG": "xfd349460--90fd95--right",
  "x6": "xfd349460--90fd95--button",
};

module.exports = exports;
